<template lang="pug">
  .wrap
    Jumbo
    Intro
    .home
      Trx
      Gym
      Box
      Crossfit
</template>

<script>
import Trx from '@/components/skechers/Trx'
import Gym from '@/components/skechers/Gym'
import Box from '@/components/skechers/Box'
import Crossfit from '@/components/skechers/Crossfit'
import Jumbo from '@/components/Jumbo'
import Intro from '@/components/skechers/Intro'

export default {
  name: 'home',
  components: {
    Trx,
    Gym,
    Box,
    Crossfit,
    Jumbo,
    Intro
  }
}
</script>
<style lang="scss">
.home{
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
  margin-bottom: 4rem;
}
</style>
